import LineGuidedtoursIcon from 'LuxKit/Icons/line/LineGuidedtoursIcon'
import LineHotAirBalloonIcon from 'LuxKit/Icons/line/LineHotAirBalloonIcon'
import LinePlaneFlyIcon from 'LuxKit/Icons/line/LinePlaneFlyIcon'
import LineRestaurantIcon from 'LuxKit/Icons/line/LineRestaurantIcon'
import LineStarIcon from 'LuxKit/Icons/line/LineStarIcon'
import LineTheatreIcon from 'LuxKit/Icons/line/LineTheatreIcon'
import LineTicketIcon from 'LuxKit/Icons/line/LineTicketIcon'
import LineWellnessIcon from 'LuxKit/Icons/line/LineWellnessIcon'
import { rem } from 'polished'
import styled, { keyframes } from 'styled-components'
import eases from 'styles/tools/eases'

const FadingAnimation = keyframes`
  0% {
    opacity: 0;
  }

  4% {
    opacity: 1;
  }

  12% {
    opacity: 1;
  }

  16% {
    opacity: 0;
  }

  100% {
    opacity: 0;
  }
`

const AnythingWrapper = styled.div`
  position: relative;

  height: ${rem(24)};
  width: ${rem(24)};

  > * {
    position: absolute;
    opacity: 0;
    animation: ${FadingAnimation} 12s infinite ${eases.sine.inOut};
    inset: 0;
  }

  @media (prefers-reduced-motion: reduce) {
    > * {
      display: none;
      animation: none;
    }

    .fallback {
      display: block;
      opacity: 1;
    }
  }
`

function ExperienceAnythingCategoryIcon() {
  return (<AnythingWrapper>
    <LineRestaurantIcon style={{ animationDelay: '0s' }} />
    <LineHotAirBalloonIcon style={{ animationDelay: '1.5s' }} />
    <LineWellnessIcon style={{ animationDelay: '3s' }} />
    <LineTicketIcon style={{ animationDelay: '4.5s' }} />
    <LineTheatreIcon style={{ animationDelay: '6s' }} />
    <LinePlaneFlyIcon style={{ animationDelay: '7.5s' }} />
    <LineStarIcon className="fallback" style={{ animationDelay: '9s' }} />
    <LineGuidedtoursIcon style={{ animationDelay: '10.5s' }} />
  </AnythingWrapper>)
}

export default ExperienceAnythingCategoryIcon
